import { useId } from 'react';

// Constellation
import { Paragraph, Text, ToggleCard } from '@zillow/constellation-10';

// Types
type PriceCardPropTypes = {
  description: string;
  handleClick: () => void;
  isActive: boolean;
  title: string;
};

const PriceCard = ({ description, handleClick, isActive, title }: PriceCardPropTypes) => {
  const descriptionId = useId();
  return (
    <ToggleCard
      elevated={false}
      tone="neutral"
      dividers={false}
      selected={isActive}
      onSelectedChange={handleClick}
      aria-describedby={descriptionId}
      css={{ marginBottom: '400' }}
      header={<Text textStyle="body-bold">{title}</Text>}
      body={
        <Paragraph id={descriptionId} textStyle="body-sm" color="text.subtle">
          {description}
        </Paragraph>
      }
    />
  );
};

export default PriceCard;
